import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

// any css-in-js or other libraries you want to use server-side
import PackageTableComponent from './PackageSummary/PackageTableComponent.tsx';
import PackageDetailsComponent from './PackageDetails/PackageDetailsComponent.tsx';

// make sure i18n is part of the bundle
import "../../Scripts/App/i18n";

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.Components = { PackageTableComponent, PackageDetailsComponent };